// Common food allergens (EU 14 + a couple more).
export const ALLERGEN_OPTIONS = [
  { key: "gluten", label: "Gluten" },
  { key: "wheat", label: "Wheat" },
  { key: "crustaceans", label: "Crustaceans" },
  { key: "eggs", label: "Eggs" },
  { key: "fish", label: "Fish" },
  { key: "peanuts", label: "Peanuts" },
  { key: "soybeans", label: "Soybeans" },
  { key: "milk", label: "Milk" },
  { key: "nuts", label: "Tree nuts" },
  { key: "celery", label: "Celery" },
  { key: "mustard", label: "Mustard" },
  { key: "sesame", label: "Sesame" },
  { key: "sulphites", label: "Sulphites" },
  { key: "lupin", label: "Lupin" },
  { key: "molluscs", label: "Molluscs" },
  { key: "alcohol", label: "Alcohol" },
];

const LABEL_MAP = Object.fromEntries(ALLERGEN_OPTIONS.map((a) => [a.key, a.label]));

export const labelForAllergen = (key) => LABEL_MAP[key] || key;

export function aggregateRecipeAllergens(recipe, ingredientsById) {
  const set = new Set();
  (recipe.ingredients || []).forEach((line) => {
    const ing = ingredientsById[line.ingredient_id];
    (ing?.allergens || []).forEach((a) => set.add(a));
  });
  return Array.from(set);
}
